// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1_2M_","head":"Table_head__NiC_W","col":"Table_col__18TGY"};